import { outcomeAttributionConfigSchema } from "@redotech/redo-attribution-common/attribution-settings";
import { attributedMetricSchema } from "@redotech/redo-marketing-common/attribution";
import { performanceRowSchema } from "@redotech/redo-marketing-common/performance-report";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPerformanceReport = {
  name: "getPerformanceReport" as const,
  input: z
    .object({
      from: zExt.instant().describe("Start instant, inclusive"),
      to: zExt.instant().describe("End instant, exclusive"),
      controls: outcomeAttributionConfigSchema
        .nullable()
        .describe(
          "Order settings to report on in place of the saved ones; null reports on the saved ones",
        ),
      includeBotClicks: z
        .boolean()
        .optional()
        .describe(
          "Whether bot clicks count, in place of the saved setting; omitted keeps the saved one",
        ),
    })
    .refine((input) => Temporal.Instant.compare(input.from, input.to) < 0, {
      message: "from must be before to",
    }),
  output: z.object({
    /** Every order in the range, attributed or not. */
    store: attributedMetricSchema,
    rows: z.array(performanceRowSchema),
    /** The same report on the saved settings, or null when the controls
     *  change nothing. */
    defaultRows: z.array(performanceRowSchema).nullable(),
    /** The saved order settings, which the controls start from. */
    saved: outcomeAttributionConfigSchema,
    savedIncludeBotClicks: z.boolean(),
  }),
};
